// extracted by mini-css-extract-plugin
export var accordionArrow = "Accordion-module--accordionArrow--63tCj";
export var accordionButton = "Accordion-module--accordion-button--4wGw9";
export var accordionContent = "Accordion-module--accordion-content--bZ5ga";
export var accordionContentWrap = "Accordion-module--accordion-content-wrap--HUeQ5";
export var accordionItem = "Accordion-module--accordion-item--md3at";
export var accordionItemOpen = "Accordion-module--accordion-item-open--MP+9U";
export var accordionTitle = "Accordion-module--accordion-title--SK82q";
export var accordionTitleInner = "Accordion-module--accordion-title-inner--15FiW";